export const EMAIL_TEMPLATE_SETTINGS = {
  bg_page_image: "#ffffff",
  fontcolor_post: "#000000",
  font_secondary: "Lato",
  fontsize_secondary: 18,
  show_author: 1,
  post_scale: "fill",
  bg_post_color: "#ffffff"
};
